import { Controller } from "@hotwired/stimulus"

// Reveals a line chart column's hover overlay (vertical indicator line, focus
// rings, and tooltip) while the pointer is within that column's hit-zone.
// Each hit-zone dispatches `show` with its index; `hide` clears everything.
export default class extends Controller {
  static targets = ["column"]

  show(event) {
    const index = Number(event.params.index)
    this.columnTargets.forEach((column, i) => {
      column.classList.toggle("hidden", i !== index)
    })
  }

  hide() {
    this.columnTargets.forEach((column) => column.classList.add("hidden"))
  }
}
